import { useContext, useEffect, useMemo, useState } from "react";
import { ChevronRight } from "lucide-react";
import { analectById, gateById, nextUnbrokenGate, stripNoteMarks } from "../../engine";
import { GameSurfaceIntegrated } from "../../state/GameSurfaceVisibility";
import { Sfx } from "../../fx/sfx";
import { useGame } from "../../state/GameProvider";

export function QuoteTablet() {
  const integrated = useContext(GameSurfaceIntegrated);
  const { state, actions } = useGame();
  const { duel } = state;
  const analect = analectById.get(duel.analectId);
  if (!analect) return null;

  const nextGate = nextUnbrokenGate(duel);
  const text = useMemo(() => stripNoteMarks(analect.text), [analect.id, analect.text]);
  const [visible, setVisible] = useState(text.length);
  const textDensity = text.length > 190 ? " epic" : text.length > 110 ? " dense" : text.length > 60 ? " long" : "";
  const won = duel.status === "won";
  const displayText = visible >= text.length ? text : text.slice(0, visible);

  useEffect(() => {
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion || integrated) {
      setVisible(text.length);
      return;
    }

    setVisible(0);
    let index = 0;
    let tick = 0;
    const step = 1;
    const intervalMs = text.length > 220 ? 92 : text.length > 120 ? 104 : 116;
    const timer = window.setInterval(() => {
      index = Math.min(text.length, index + step);
      tick += 1;
      setVisible(index);
      if (tick % 3 === 0 || index === text.length) Sfx.type();
      if (index >= text.length) window.clearInterval(timer);
    }, intervalMs);

    return () => window.clearInterval(timer);
  }, [analect.id, text, integrated]);

  return (
    <article className={`tablet tone-${nextGate}`} aria-label={`${analect.chapter} ${analect.major}.${analect.minor}`}>
      <p className={`tablet-text${textDensity}${visible < text.length ? " typing" : ""}`} aria-label={text}>
        <span className="tablet-line">
          <span>{displayText}</span>
          {visible < text.length && <span className="type-caret" aria-hidden />}
        </span>
      </p>

      {!integrated && <div className="tablet-foot">
        <span className="tablet-seal" aria-hidden>
          論
        </span>
        {won ? (
          <span className="tablet-cleared">{integrated ? "本次四門練習完成" : "本則已掌握 · 四門皆破"}</span>
        ) : (
          <button className="break-btn" onClick={() => actions.play(nextGate)} disabled={duel.status === "lost"}>
            <span>{`破「${gateById(nextGate).label}」門`}</span>
            <ChevronRight size={16} />
          </button>
        )}
      </div>}
    </article>
  );
}
